/** 工作日志与日常任务共用的工作类型编码及展示名称。 */
export const WORK_TYPE_OPTIONS = [
  { value: 'xc', label: '巡查' },
  { value: 'wb', label: '维保' },
  { value: 'cs', label: '测试' },
  { value: 'ls', label: '临时工作' },
  { value: 'zyrw', label: '重要任务' }
];
